import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NodesService} from '../../../../+sites/document-library/shared/services/nodes.service';

class SiteValidator {
  public static ValidatorID(id: FormControl) {
    if (id.value.match('[^A-Za-z0-9]+')) {
      return {
        idError: true
      };
    } else {
      return null;
    }
  }
}

@Component({
  selector: 'app-dialog-create-site',
  templateUrl: './dialog-create-site.component.html',
  styleUrls: ['./dialog-create-site.component.scss']
})
export class DialogCreateSiteComponent implements OnInit {
  public loadingPage: boolean;
  public form: FormGroup;
  public error: string;
  public isEdit = false;
  public site: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogCreateSiteComponent>,
    private node: NodesService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    if (this.data) {
      this.isEdit = this.data.isEdit;
      this.site = this.data.site;
    }
    this.loadingPage = false;
    this.error = '';
    this.initialize();
  }

  createSite() {
    this.error = '';
    const data = {
      name: this.form.controls["name"].value,
      description: this.form.controls["description"].value,
      visibility: 'PRIVATE',
      
    };
    let request;
    if (this.isEdit) {
      request = this.node.updateSite(this.form.value, this.site.id);
    }else {
     
      request = this.node.createSite(this.form.value);
    }

    
    request
    .then(res => {
      this.dialogRef.close(res);
    })
    .catch(err => {
      this.error = 'Le nom est déjà utilisé. Les noms de dossier doivent être uniques.';
 
    })
    .finally(() => (this.loadingPage = false));
  }

  private initialize() {
    this.form = this.fb.group({
      name: [this.isEdit ? this.site.title : "", [Validators.required]],
      visibility: 'PRIVATE',
      description: [this.isEdit ? this.site.description : "", []],
      id: [this.isEdit ? this.site.id : "", [SiteValidator.ValidatorID]]
    });
  }
}
